import { ActionDescriptor, Scope } from "./types";

/** Playground stub — the guide previews structure + bindings, not live server
 *  actions. Clicking a Button/Form here does nothing (no run, no network). */
export async function dispatchAction(_action: ActionDescriptor, _scope: Scope): Promise<void> {
  /* no-op */
}
